import { provider, firebaseAuth } from './firebaseSetup';
import {useState, useEffect} from 'react';

export function useAuthService() {
    const [userData, setUserData] = useState(null);

    const successLoginCallback = (user) => {
        const data = {
            displayName: user.displayName,
            email: user.email,
            uid: user.uid
        }

        setUserData(data);
        return data;
    }

    const login = () => {
        return firebaseAuth.signInWithPopup(provider)
            .then(({ user }) => successLoginCallback(user));
    }

    const logout = () => {
        return firebaseAuth.signOut()
            .then(() => setUserData(null));
    }

    


    useEffect(() => 
        firebaseAuth.onAuthStateChanged((user) => user ? successLoginCallback(user) : null)
    , [])

    return [userData, login, logout];
}